// extracted by mini-css-extract-plugin
export default {"cards":"Card_cards__715AS","img":"Card_img__+FDMN","badge":"Card_badge__bOuSd"};